/*
	ACTIONS
*/
//------------------------------------------------------------
// SHOW SYSTEM
//------------------------------------------------------------

const showSystem = ({commit}, bool) => {
    commit('SHOW_SYSTEM', bool);
}
//------------------------------------------------------------
// EXPORT
//------------------------------------------------------------

export default {
	showSystem
}
//===========================================
//
//===========================================